import { Subject } from 'rxjs/Subject';
import { Directive, ElementRef, Renderer, Input, OnInit, OnDestroy, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';

@Directive({ selector: '[rx-click]' })
export class RxClickDirective implements OnDestroy, OnChanges {
    
    @Input('rx-click')
    private subject: Subject<any>;
    private listener: any;

    constructor(private el: ElementRef) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['subject']) {
            this.removeListener();
            this.listener = () => this.subject.next(true);
            this.el.nativeElement.addEventListener('click', this.listener);
        }
    }

    ngOnDestroy() {
        this.removeListener();
    }

    private removeListener() {
        this.el.nativeElement.removeEventListener('click', this.listener);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/rx.directive.ts